import { render, staticRenderFns } from "./RandomProductBanner.vue?vue&type=template&id=6c405e25&scoped=true&"
var script = {}
import style0 from "./RandomProductBanner.vue?vue&type=style&index=0&id=6c405e25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c405e25",
  null
  
)

export default component.exports